import { useContext } from 'react';
import { WindowSizeContext } from 'store/WindowSizeContext';

export const useWindowSize = () => {
  const windowWidth = useContext(WindowSizeContext);

  return windowWidth;
};
